import { TipoNotaOcorrencia } from "./enum";

export class NotaFiscalOcorrencia {
  id: number;
  idOcorrencia: number;
  numeroNota: string;
  valor: number;
  dataEmissao: Date;
  tipoNota: TipoNotaOcorrencia;
  xml: string;
}
